const optOut = () => {

  (function() {
    var e = $("#tmpl-optoutwidget"),
        t = $("#optoutwidget");
    t.html(e.html())
  })();

  (function() {
      function e() {
          n = {}, t = document.cookie.split(";");
          for (var e = 0, r = t.length; r > e; e++) {
              var l = t[e],
                  f = l.indexOf("="),
                  h = l.slice(0, f).trim(),
                  m = l.slice(f + 1).trim();
              n[h] = m
          }
          n[a] && "DNT" === n[a] ? (u = !0, i.removeClass("optoutstatus-in").addClass("optoutstatus-out"), s.html("Out"), c.html("in"), d.html("Opt In")) : (u = !1, i.removeClass("optoutstatus-out").addClass("optoutstatus-in"), s.html("In"), c.html("out"), d.html("Opt Out"))
      }
      var t = document.cookie.split(";"),
          n = {},
          a = "vampid",
          r = ".videoamp.com",
          i = $(".optoutstatusbox"),
          s = $(".optoutmsg"),
          d = $(".optoutbtn"),
          c = $(".optoutbtn-status"),
          u = !1;
      e(), d.on("click", function() {
          var t, n = new Date;
          u ? (n.setFullYear(n.getFullYear() - 1), t = a + "=;expires=" + n.toGMTString() + ";path=/;domain=" + r) : (n.setFullYear(n.getFullYear() + 30), t = a + "=DNT;expires=" + n.toGMTString() + ";path=/;domain=" + r), document.cookie = t, e()
      })
  })();

  $(function() {
    $('.optoutbtn').on("click", function(){
      $.get("https://usersync.videoamp.com/optout");
    })
  });

}

export {
  optOut
}